import { render } from "./OuterFileCompletePage.vue?vue&type=template&id=0829271d&scoped=true&ts=true"
import script from "./OuterFileCompletePage.vue?vue&type=script&lang=ts"
export * from "./OuterFileCompletePage.vue?vue&type=script&lang=ts"

import "./OuterFileCompletePage.vue?vue&type=style&index=0&id=0829271d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0829271d"]])

export default __exports__